import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import OurStorySection from '../components/OurStorySection';
import MissionVisionSection from '../components/MissionVisionSection';
import WhyChooseSection from '../components/WhyChooseSection';
import AchievementsSection from '../components/AchievementsSection';
import AboutHeroSection from '../components/AboutHeroSection';
import '../styles/AboutUs.css';

const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-us-page">
      <AboutHeroSection />

      <OurStorySection />

      <MissionVisionSection />

      <WhyChooseSection />

      <AchievementsSection />

      <section className="about-section about-cta">
        <div className="about-container">
          <div className="cta-content">
            <h2 className="cta-title">Ready to Find Your Dream Property?</h2>
            <p className="cta-subtitle">
              Join thousands of satisfied customers who found their perfect property through 360Coordinates
            </p>
            <div className="cta-buttons">
              <Link to="/login" className="cta-button cta-primary">
                Start Searching
              </Link>
              <Link to="/login" className="cta-button cta-secondary">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutUs;
